export const testimonials = [
  {
    id: 1,
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20man%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20simple%20studio%20background%2C%20warm%20natural%20lighting%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-01&orientation=squarish',
    role: '忠实读者 · 阅读3年',
    content: '韩国漫画网的更新速度真的没话说，每天都能看到最新的汉化章节。下拉式阅读体验特别流畅，再也不用翻页等加载了，不知不觉就能看几十话！',
    rating: 5,
  },
  {
    id: 2,
    name: '小琳同学',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20woman%20portrait%2C%20warm%20smile%2C%20natural%20makeup%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-02&orientation=squarish',
    role: '恋爱漫画爱好者',
    content: '这里的恋爱韩漫分类特别全，每部作品都有详细的标签筛选。自从发现这个网站，周末窝在家刷韩漫成了我最幸福的时光！',
    rating: 5,
  },
  {
    id: 3,
    name: '深夜读者阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20man%20portrait%20with%20glasses%2C%20thoughtful%20expression%2C%20clean%20studio%20background%2C%20warm%20lighting%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-03&orientation=squarish',
    role: '奇幻漫画迷',
    content: '作为韩漫老读者，我用过很多平台，韩国漫画网的画质是最高的。每张漫画都高清呈现，黑暗神殿那种大场面看得特别过瘾。强烈推荐！',
    rating: 5,
  },
];